class HeartbeatService {
    constructor($interval, Restangular, shopperService, config, $window) {
        this.$interval = $interval;
        this.api = Restangular.one('heartbeat');
        this.shopperService = shopperService;
        this.$window = $window;

        this.config = config;
    }

    get jwtExpiryRefreshInterval() {
        return 1000 * 60 * this.config.JwtExpiryMinutes / 2;
    }

    /**
     * This function get the current server side version and check if context is valid. If the api call
     * returns a 200 ok then the context is considered valid. Otherwise if the api call returns a 401 then
     * the application will deal with that globally as a side effect.
     */
    checkContextIsValid() {
        if (!this.shopperService.IsGuest) {
            this.api.one('context').get().then(response => this.checkVersionInfo(response));
        } else {
            this.api.one('guest').get().then(response => this.checkVersionInfo(response));
        }
    }

    checkVersionInfo(response) {
        if (response.VersionInfo !== this.config.CurrentVersion) {
            this.$window.location.reload();
        }
    }

    startWaitingForContextExpiry() {
        if (this.contextExpiryInterval) {
            this.$interval.cancel(this.contextExpiryInterval);
        }

        let interval = this.config.ContextExpiryPeriod + 60000;
        if (this.config.JwtsEnabled) {
            interval = this.jwtExpiryRefreshInterval;
        }

        this.contextExpiryInterval = this.$interval(() => this.checkContextIsValid(), interval);
    }

    startContextHeartbeat() {
        this.startWaitingForContextExpiry();
    }
}

module.exports = HeartbeatService;



// WEBPACK FOOTER //
// ./src/common/heartbeat/heartbeat.service.js